<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ title }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right" v-if="!communities.id">
          <base-button size="sm" type="neutral" v-b-modal.communities-modal>
            <span class="btn-inner--icon"><i class="fas fa-user-friends mr-1"></i></span>
            <span class="btn-inner--text">Join a Community</span>
          </base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row class="align-self-stretch" v-if="community">
        <b-col md="5">
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">Community Tracking Sources</h3>
            </b-card-header>
            <b-card-body>
              <b-form @submit.prevent="store">
                <b-input-group>
                  <b-form-input label="Tracking Source:" v-model="source" placeholder="New Source..."></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" type="submit" variant="success">Submit</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form>
              <div class="text-center">
                <b-button class="mt-3" variant="outline-danger" v-b-modal.recommended>Recommendations</b-button>
              </div>
            </b-card-body>
            <b-list-group flush v-if="trackingSources.length > 0">
              <b-list-group-item v-for="source in trackingSources" :key="source.id" class="d-flex justify-content-between align-items-center">
                {{ source.name }}
                <b-button variant="danger" size="sm" @click="destroy(source.id)" class="float-right">Delete</b-button>
              </b-list-group-item>
            </b-list-group>
            <h4 class="text-center text-danger pb-2" v-else>Currently no community tracking sources</h4>
          </b-card>
        </b-col>
        <b-col md="7">
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">{{ community.name }} Members</h3>
            </b-card-header>
            <b-table small responsive :items="users" :fields="fields"></b-table>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="communities.id">
        <b-col md="4">
          <b-card
            :title="communities.name"
            :img-src="communities.logo ? communities.logo : 'https://fakeimg.pl/600x400?text=Placeholder'"
            :img-alt="communities.name + ' logo'"
            img-top
            tag="article"
            class="h-100"
            no-body>
            <b-card-body class="d-flex flex-column">
              <b-card-header class="border-0 pr-0 pb-2 pl-0 pt-0">
                <h3 class="mb-0">{{ communities.name }}</h3>
              </b-card-header>
              <b-card-text>
                <span v-html="communities.description"></span>
              </b-card-text>
              <b-row class="mt-auto">
                <b-col>
                  <b-button block variant="danger" @click="leaveCommunity(communities.id)">Leave Community</b-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <communities-modal></communities-modal>
    <b-modal id="recommended" title="Recommended Sources" hide-footer>
      <h4>Below is a list of recommended sources to use in your Community Tracking.</h4>
      <b-row>
        <b-col md="6">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Hours
              <b-button size="sm" variant="success" @click="addRecommended('Hours')"><i class="fas fa-add"></i></b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Dials
              <b-button size="sm" variant="success" @click="addRecommended('Dials')"><i class="fas fa-add"></i></b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Contacts
              <b-button size="sm" variant="success" @click="addRecommended('Contacts')"><i class="fas fa-add"></i></b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Listing Nurtures
              <b-button size="sm" variant="success" @click="addRecommended('Listing Nurtures')"><i class="fas fa-add"></i></b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Listings Set
              <b-button size="sm" variant="success" @click="addRecommended('Listings Set')"><i class="fas fa-add"></i></b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Listings Held
              <b-button size="sm" variant="success" @click="addRecommended('Listings Held')"><i class="fas fa-add"></i></b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Listings Taken
              <b-button size="sm" variant="success" @click="addRecommended('Listings Taken')"><i class="fas fa-add"></i></b-button>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Listings Sold
              <b-button size="sm" variant="success" @click="addRecommended('Listings Sold')"><i class="fas fa-add"></i></b-button>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col md="6">
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Buyer Nurtures
            <b-button size="sm" variant="success" @click="addRecommended('Buyer Nurtures')"><i class="fas fa-add"></i></b-button>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Buyers Set
            <b-button size="sm" variant="success" @click="addRecommended('Buyers Set')"><i class="fas fa-add"></i></b-button>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Buyers Held
            <b-button size="sm" variant="success" @click="addRecommended('Buyers Held')"><i class="fas fa-add"></i></b-button>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Buyers Signed
            <b-button size="sm" variant="success" @click="addRecommended('Buyers Signed')"><i class="fas fa-add"></i></b-button>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Buyers Sold
            <b-button size="sm" variant="success" @click="addRecommended('Buyers Sold')"><i class="fas fa-add"></i></b-button>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Price Corrections
            <b-button size="sm" variant="success" @click="addRecommended('Price Corrections')"><i class="fas fa-add"></i></b-button>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            Offers Written
            <b-button size="sm" variant="success" @click="addRecommended('Offers Written')"><i class="fas fa-add"></i></b-button>
          </b-list-group-item>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CommunitiesModal from '@/views/Components/Modals/CommunitiesModal';

export default {
  components: {
    RouteBreadCrumb,
    CommunitiesModal
  },
  data() {
    return {
      community: null,
      users: [],
      trackingSources: [],
      source: null,
      type: 'community',
      fields: ['name', 'realty_role', 'member_since']
    }
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute',
      communities: 'communities/communities'
    }),
    title() {
      return 'Communities';
    }
  },
  methods: {
    async getCommunity() {
      await axios.get(this.userRoute + "/community")
      .then(response => {
        if (Object.keys(response.data).length > 0) {
          this.community = response.data;
        }
        
        if (this.community) {
          this.getTrackingSources();
          this.getCommunityUsers();
        }
      })
      .catch(error => {
        // 
      });
    },
    async getCommunityUsers() {
      await axios.get(this.userRoute + "/community/members")
      .then(response => {
        this.users = response.data;
      })
      .catch(error => {
        // 
      });
    },
    async leaveCommunity(community_id) {
      await axios.post(this.userRoute + "/communities/leave", {
        community_id: community_id
      })
      .then(response => {
        this.$store.dispatch('communities/get', {user: this.user.slug});
      })
      .catch(error => {
        // 
      });
    },
    async getTrackingSources() {
      await axios.get(this.userRoute + "/community/tracking-sources")
      .then(response => {
        this.trackingSources = response.data;
      })
      .catch(error => {
        this.error(error);
      })
    },
    async store() {
      await axios.post(this.userRoute + "/tracking-sources", {
        name: this.source,
        type: this.type
      })
      .then(response => {
        this.$emit('getTrackingSources');
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.source = null;
          this.getTrackingSources();
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async destroy(source) {
      await axios.delete(this.userRoute + "/tracking-sources/" + source)
      .then(response => {
        this.$emit('getTrackingSources');
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.getTrackingSources();
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    addRecommended(source) {
      this.source = source;
      this.store();
    }
  },
  mounted() {
    document.title = this.title + " | ClarityNOW";
  },
  created() {
    this.getCommunity();
  }
}
</script>